export default "__VITE_ASSET__KuAknwFQ__"